// app.js (ESM)
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

/* ========= Helpers ========= */

// only front-end
if (document.documentElement.classList.contains('wp-admin') === false) {


    // =========================
    // Testimonials Swiper
    // =========================
    const testimonialEl = document.querySelector(".testimonials-swiper");

    if (testimonialEl && typeof Swiper !== "undefined") {
      const counterEl = document.getElementById("testimonials-counter");
      const progressEl = document.getElementById("testimonials-progress");

      const swiper = new Swiper(".testimonials-swiper", {
        loop: false,
        slidesPerView: 1,
        autoHeight: true,
        speed: 600,
        navigation: {
          nextEl: ".js-testimonial-next",
          prevEl: ".js-testimonial-prev",
        },
        on: {
          init(swiper) {
            toggleCounterVisibility(swiper);
            updateCounter(swiper);
            updateProgress(swiper);
          },
          slideChange(swiper) {
            updateCounter(swiper);
            updateProgress(swiper);
          },
        },
      });

      function toggleCounterVisibility(swiper) {
        const total = swiper.slides.length - (swiper.loop ? swiper.loopedSlides * 2 : 0);
        const shouldShow = total > 1;
        if (counterEl) {
          counterEl.style.display = shouldShow ? "" : "none";
        }
        if (progressEl) {
          progressEl.style.display = shouldShow ? "" : "none";
        }
      }

      function updateCounter(swiper) {
        if (!counterEl) return;
        const total = swiper.slides.length - (swiper.loop ? swiper.loopedSlides * 2 : 0);
        const current = swiper.realIndex + 1;
        const formatted = `${String(current).padStart(2, "0")}/${String(total).padStart(2, "0")}`;
        counterEl.textContent = formatted;
      }

      function updateProgress(swiper) {
        if (!progressEl) return;
        const total = swiper.slides.length - (swiper.loop ? swiper.loopedSlides * 2 : 0);
        const current = swiper.realIndex + 1;
        const percent = (current / total) * 100;
        progressEl.style.width = `${percent}%`;
      }
    }

      // =========================
  // Team Swiper
  // =========================
  const teamEl = document.querySelector(".team-swiper");

  if (teamEl && typeof Swiper !== "undefined") {
    const swiper = new Swiper(teamEl, {
      loop: false,
      speed: 600,
      spaceBetween: 32,
      autoHeight: true,
      navigation: {
        nextEl: ".js-team-next",
        prevEl: ".js-team-prev",
      },
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  }


        // =========================
  // Projects Swiper
  // =========================
  const projectEl = document.querySelector(".projects-swiper");

  if (projectEl && typeof Swiper !== "undefined") {
    const swiper = new Swiper(projectEl, {
      loop: false,
      speed: 600,
      spaceBetween: 32,
      // autoHeight: true,
      navigation: {
        nextEl: ".js-team-next",
        prevEl: ".js-team-prev",
      },
      slidesPerView: 1,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 32,
        },
      },
    });
  }




    // Register GSAP plugins
    gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

    //  Smoother 
    const smoother = ScrollSmoother.create({
      smooth: 2,
      effects: true,
    });


    // =========================
    // Header Animation
    // =========================
    const initShowHideHeader = () => {
      const header = document.querySelector('#header');
      const showHeaderAnim = gsap.from(header, {
          yPercent: -100,
          paused: true,
          duration: 0.3
      }).progress(1);

      ScrollTrigger.create({
          trigger: "#header",
          start: `bottom top`,
          // markers: true,
          end: 99999,
          onUpdate: (self) => {
              self.direction === -1 ? showHeaderAnim.play() : showHeaderAnim.reverse();
          }
      });

  }
  initShowHideHeader();



    // -----------------------
    // Back To Top
    // ------------------------
    const backToTopBtn = document.querySelector("[data-backtotop]");
    if (backToTopBtn) {
      backToTopBtn.addEventListener("click", (e) => {
        e.preventDefault();
        smoother.scrollTo(0, true);
      });
    }


    // -----------------------
  // Header Animation
  // -----------------------
  const header = document.querySelector("[data-animate-header]");
  gsap.from(header, {
    yPercent: -100,
    duration: 1,
    ease: "power4.out",
    delay: 0.4,
    scrollTrigger: {
      trigger: header,
      start: "top top",
      once: true
    }
  });
  

// -----------------------
// SplitText + Fade animations per section 
// -----------------------
document.fonts.ready.then(() => {
  gsap.utils.toArray("section").forEach((section) => {
    // Get all animatable elements in DOM order
    const items = section.querySelectorAll(
      "[data-animate-heading], [data-animate-paragraphs], [data-animate-paragraph], [data-animate-zoom-in], [data-animate-fade-up], [data-animate-line], [data-animate-video]"
    );

    if (!items.length) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 75%",
        once: true,
        // markers: true,
      },
    });

    tl.call(() => {
      items.forEach((n) => n.style.visibility = "visible");
    }, null, 0);

    items.forEach((el, index) => {
      // tiny overlap between each item
      const position = index === 0 ? 0 : "<+=0.2";

      // 1) Heading
      if (el.hasAttribute("data-animate-heading")) {
        const split = SplitText.create(el, {
          type: "lines, words",
          linesClass: "line",
          mask: "words",
        });

        tl.fromTo(
          split.lines,
          {
            clipPath: "inset(0% 0% 100% 0%)",
            opacity: 0,
            yPercent: 200,
            scaleX: 0.95,
            rotateX: 60,
          },
          {
            clipPath: "inset(0% 0% 0% 0%)",
            opacity: 1,
            yPercent: 0,
            scaleX: 1,
            duration: 1.2,
            stagger: 0.1,
            rotateX: 0,
            transformOrigin: "50% 100%",
            ease: "expo.out",
            delay: index === 0 ? 0.2 : 0,
          },
          position
        );
      }

      // 2) Paragraphs (multiple <p> children)
      else if (el.hasAttribute("data-animate-paragraphs")) {
        const blocks = el.querySelectorAll("p, ul, ol");
        const targets = blocks.length ? blocks : [el];

        targets.forEach((target, idx) => {
          const splitTarget = target;

          if (target.tagName === "UL" || target.tagName === "OL") {
            const startAt = idx === 0 ? position : "<+=0.2";
            tl.from(
              target,
              {
                duration: 0.8,
                y: 20,
                opacity: 0,
                ease: "power2.out",
              },
              startAt
            );
            return;
          }

          const split = SplitText.create(splitTarget, {
            type: "lines, words",
            linesClass: "line",
            mask: "words",
          });

          const startAt = idx === 0 ? position : "<+=0.2";

          tl.from(
            split.lines,
            {
              duration: 1.0,
              yPercent: 100,
              opacity: 0,
              clipPath: "inset(0% 0% 100% 0%)",
              transformOrigin: "50% 100%",
              stagger: 0.08,
              ease: "expo.out",
            },
            startAt
          );
        });
      }

      // 3) Paragraph (single block)
      else if (el.hasAttribute("data-animate-paragraph")) {
        const split = SplitText.create(el, {
          type: "lines, words",
          linesClass: "line",
          mask: "words",
        });

        tl.from(
          split.lines,
          {
            duration: 1.0,
            yPercent: 100,
            opacity: 0,
            clipPath: "inset(0% 0% 100% 0%)",
            transformOrigin: "50% 100%",
            stagger: 0.08,
            ease: "expo.out",
          },
          position
        );
      }

      // 4) Zoom-in
      else if (el.hasAttribute("data-animate-zoom-in")) {
        tl.from(
          el,
          {
            opacity: 0,
            scale: 1.2,
            duration: 1.0,
            ease: "power2.out",
          },
          position
        );
      }

      // 5) Fade-up
      else if (el.hasAttribute("data-animate-fade-up")) {
        tl.from(
          el,
          {
            y: 40,
            opacity: 0,
            scale: 0.98,
            willChange: "transform,opacity,filter",
            duration: 1.0,
            ease: "power3.out",
            clearProps: "transform,opacity,filter,willChange",
          },
          position
        );
      }

      // 6) Line  
      else if (el.hasAttribute("data-animate-line")) {
        gsap.set(el, { transformOrigin: "left center" });
        tl.from(
          el,
          {
            scaleX: 0,
            duration: 1.0,
            ease: "power2.out",
          },
          // position  
          index === 0 ? 0 : "<-=0.25"
        );
      }

      else if(el.hasAttribute("data-animate-video")) {
        const video = el.tagName === "VIDEO" ? el : el.querySelector("video");
        if (!video) return;
        if (video.dataset.videoScrollInit === "true") return;
        video.dataset.videoScrollInit = "true";

        const triggerEl = video.closest(".block-half-textvideo") || video;
        const safePlay = () => {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        };

        ScrollTrigger.create({
          trigger: triggerEl,
          start: "top 70%",
          end: "bottom 30%",
          onEnter: safePlay,
          onEnterBack: safePlay,
          onLeave: () => video.pause(),
          onLeaveBack: () => video.pause(),
        });
      }
    });
  });

  ScrollTrigger.refresh();
});


// -----------------------
// Count-Up animation for stats
// -----------------------
gsap.utils.toArray("[data-animate-counter]").forEach((el) => {
  const rawValue = el.getAttribute("data-animate-counter") || "";
  const sanitized = rawValue.replace(/,/g, "");
  const endValue = parseFloat(sanitized);
  if (Number.isNaN(endValue)) return;

  const decimals = (sanitized.split(".")[1] || "").length;
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  const obj = { value: 0 };
  el.textContent = formatter.format(0);

  gsap.to(obj, {
    value: endValue,
    duration: 1.8,
    ease: "power1.out",
    scrollTrigger: {
      trigger: el.closest("section"),
      start: "top center",
      once: true,
    },
    onUpdate: function () {
      el.textContent = formatter.format(obj.value);
    },
  });
});
  

/*
  // -----------------------
  // Fade-In per section
  // -----------------------
  gsap.utils.toArray("section").forEach((section) => {
    const fadeInEls = section.querySelectorAll(".animate-fade-in");
    if (!fadeInEls.length) return;

    gsap.from(fadeInEls, {
      scrollTrigger: {
        trigger: section,
        start: "top center",
        once: true,
      },
      opacity: 0,
      duration: 1.5,
      stagger: 0.15,
      ease: "power2.out",
    });
  });

  // -----------------------
  // Fade-In-Up per section
  // -----------------------
  gsap.utils.toArray("section").forEach((section) => {
    const fadeInUpEls = section.querySelectorAll(".animate-fade-in-up");
    if (!fadeInUpEls.length) return;

    gsap.from(fadeInUpEls, {
      scrollTrigger: {
        trigger: section,
        start: "top center",
        once: true,
      },
      opacity: 0,
      y: 40,
      duration: 1.5,
      stagger: 0.15,
      ease: "power3.out",
    });
  });
*/


// -----------------------
// Timeline section
// -----------------------
const initTimeline = () => {
  const section = document.querySelector('[data-timeline-section]');
  if (!section || typeof gsap === 'undefined') return;

  const timeline = section.querySelector('[data-timeline]');
  const dot = section.querySelector('[data-timeline-dot]');
  const yearEls = Array.from(section.querySelectorAll('[data-timeline-year]'));
  const entries = Array.from(section.querySelectorAll('[data-timeline-entry]'));
  const entriesWrapper = section.querySelector('[data-timeline-entries]');
  const yearsWrapper = section.querySelector('[data-timeline-years]');
  const track = section.querySelector('[data-timeline-track]');

  if (!timeline || !dot || !entriesWrapper || !yearsWrapper || !track || yearEls.length === 0 || yearEls.length !== entries.length) return;

  const getPositions = () => {
    track.style.width = `${yearsWrapper.scrollWidth}px`;
    const barRect = track.getBoundingClientRect();
    const dotOffset = dot.offsetWidth / 2;
    return yearEls.map((year) => {
      const r = year.getBoundingClientRect();
      return r.left + r.width / 2 - barRect.left - dotOffset;
    });
  };

  let positions = getPositions();

  const moveDot = gsap.quickTo(dot, 'x', {
    duration: 0.6,
    ease: 'power2.out',
  });

  const scrollYearIntoView = (index) => {
    if (!window.matchMedia("(max-width: 767px)").matches) return;

    const year = yearEls[index];
    if (!year) return;

    const timelineRect = timeline.getBoundingClientRect();
    const yearRect = year.getBoundingClientRect();
    const targetLeft =
      timeline.scrollLeft +
      (yearRect.left - timelineRect.left) -
      (timelineRect.width / 2 - yearRect.width / 2);

    timeline.scrollTo({
      left: targetLeft,
      behavior: "smooth",
    });
  };

  let currentIndex = 0;

  const setActive = (index) => {
    currentIndex = index;
    positions = getPositions();

    yearEls.forEach((el, i) => el.classList.toggle('is-active', i === index));

    entries.forEach((entry, i) => {
      gsap.to(entry, {
        autoAlpha: i === index ? 1 : 0,
        duration: 0.6,
        ease: 'power2.out',
        overwrite: 'auto',
      });
    });

    moveDot(positions[index]);
    scrollYearIntoView(index);
  };

  entries.forEach((entry, i) => {
    gsap.set(entry, { autoAlpha: i === 0 ? 1 : 0 });
  });

  const resizeWrapper = () => {
    let maxH = 0;

    entries.forEach((entry) => {
      const prevPos = entry.style.position;
      const prevTop = entry.style.top;
      const prevLeft = entry.style.left;
      const prevRight = entry.style.right;
      const prevBottom = entry.style.bottom;

      entry.style.position = 'static';
      entry.style.top = entry.style.left = entry.style.right = entry.style.bottom = '';

      const h = entry.offsetHeight;
      if (h > maxH) maxH = h;

      entry.style.position = prevPos || 'absolute';
      entry.style.top = prevTop || '0';
      entry.style.left = prevLeft || '0';
      entry.style.right = prevRight || '0';
      entry.style.bottom = prevBottom || '0';
    });

    entriesWrapper.style.height = maxH + 'px';
  };

  resizeWrapper();

  yearEls.forEach((el, i) => {
    el.addEventListener('click', () => setActive(i));
  });

  const recalc = () => {
    positions = getPositions();
    moveDot(positions[currentIndex]);
    resizeWrapper();
  };

  const recalcAfterLayout = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(recalc);
    });
  };

  window.addEventListener('resize', recalc);
  window.addEventListener('load', recalcAfterLayout);
  document.fonts?.ready?.then(recalcAfterLayout);

  if (typeof ResizeObserver !== 'undefined') {
    const ro = new ResizeObserver(recalc);
    ro.observe(yearsWrapper);
    ro.observe(dot.parentElement);
  }

  yearEls.forEach((el, i) => el.classList.toggle('is-active', i === 0));
  moveDot(positions[0]);
  recalcAfterLayout();
};

initTimeline();

// -----------------------
// Lottie autoplay on view
// -----------------------
const initLottieOnView = () => {
  const lotties = Array.from(
    document.querySelectorAll("dotlottie-wc[data-autoplay-onview]")
  );
  const placeholders = Array.from(
    document.querySelectorAll(".js-lottie-onview[data-lottie-html]")
  );

  if (!lotties.length && !placeholders.length) return;

  const loadPlaceholder = (el) => {
    const html = el.getAttribute("data-lottie-html");
    if (!html) return;
    el.innerHTML = html;
    el.removeAttribute("data-lottie-html");

    const lottie = el.querySelector("dotlottie-wc");
    if (!lottie) return;
    lottie.removeAttribute("autoplay");
    if (typeof lottie.play === "function") {
      lottie.play();
    } else {
      lottie.setAttribute("autoplay", "");
    }
  };

  const setState = (el, isInView) => {
    if (isInView) {
      if (el.hasAttribute("data-lottie-html")) {
        loadPlaceholder(el);
        return;
      }

      if (typeof el.play === "function") {
        el.play();
      } else {
        el.setAttribute("autoplay", "");
      }
      return;
    }

    if (typeof el.pause === "function") {
      el.pause();
    } else {
      el.removeAttribute("autoplay");
    }
  };

  if (typeof IntersectionObserver === "undefined") {
    placeholders.forEach((el) => loadPlaceholder(el));
    lotties.forEach((el) => setState(el, true));
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const target = entry.target;
        if (target.hasAttribute("data-lottie-html")) {
          io.unobserve(target);
          requestAnimationFrame(() => {
            loadPlaceholder(target);
          });
          return;
        }
        setState(target, true);
      });
    },
    { threshold: 0.01, rootMargin: "200px 0px" }
  );

  placeholders.forEach((el) => io.observe(el));
  lotties.forEach((el) => {
    setState(el, false);
    io.observe(el);
  });
};

initLottieOnView();

// -----------------------
// GIF load on view
// -----------------------
const initGifOnView = () => {
  const gifs = Array.from(document.querySelectorAll("img.js-gif-inview"));
  if (!gifs.length || typeof IntersectionObserver === "undefined") return;

  const defaultThreshold = 0.35;
  const getThreshold = (value) => {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : defaultThreshold;
  };

  const groups = new Map();

  gifs.forEach((img) => {
    const rootMargin = img.getAttribute("data-gif-root-margin") || "0px";
    const threshold = getThreshold(img.getAttribute("data-gif-threshold"));
    const key = `${rootMargin}|${threshold}`;
    if (!groups.has(key)) {
      groups.set(key, { rootMargin, threshold, items: [] });
    }
    groups.get(key).items.push(img);
  });

  const refreshScrollTrigger = () => {
    if (typeof ScrollTrigger === "undefined") return;
    ScrollTrigger.refresh();
  };

  groups.forEach(({ rootMargin, threshold, items }) => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const img = entry.target;
          const src = img.getAttribute("data-gif-src");
          if (src) {
            if (!img.dataset.gifRefreshBound) {
              img.dataset.gifRefreshBound = "true";
              img.addEventListener(
                "load",
                () => {
                  requestAnimationFrame(refreshScrollTrigger);
                },
                { once: true }
              );
            }
            img.src = src;
            img.removeAttribute("data-gif-src");
            if (img.complete) {
              requestAnimationFrame(refreshScrollTrigger);
            }
          }
          io.unobserve(img);
        });
      },
      { threshold, rootMargin }
    );

    items.forEach((img) => io.observe(img));
  });
};

initGifOnView();

  // News filter
    document.addEventListener('DOMContentLoaded', function () {
        const listingNewsSection = document.querySelector('.block-listing-news');
        if (!listingNewsSection) {
            return;
        }

        const newsItems = Array.from(listingNewsSection.querySelectorAll('.news-item'));
        const categoryOptions = Array.from(listingNewsSection.querySelectorAll('.filter-category .type-nav'));
        const searchInput = listingNewsSection.querySelector('#listing-search');
        const resultsLabel = listingNewsSection.querySelector('.filter-category .dropdown-result .selected-label') || listingNewsSection.querySelector('.filter-category .dropdown-result');
        const emptyState = listingNewsSection.querySelector('.news-block-none');
        const countEl = listingNewsSection.querySelector('#currentCount');

        let activeCategory = '';
        let searchQuery = '';

        const searchCache = new Map();
        newsItems.forEach((item) => {
            searchCache.set(item, item.textContent.toLowerCase());
        });

        const applyFilters = () => {
            const normalizedQuery = searchQuery.trim();
            let visibleCount = 0;

            newsItems.forEach((item) => {
                const matchesCategory = !activeCategory || item.classList.contains(activeCategory);
                const matchesSearch = !normalizedQuery || searchCache.get(item).includes(normalizedQuery);

                if (matchesCategory && matchesSearch) {
                    item.style.display = '';
                    visibleCount += 1;
                } else {
                    item.style.display = 'none';
                }
            });

            if (countEl) {
                countEl.textContent = String(visibleCount).padStart(2, '');
            }

            if (emptyState) {
                emptyState.style.display = visibleCount ? 'none' : 'block';
            }
        };

        categoryOptions.forEach((option) => {
            option.addEventListener('click', (event) => {
                event.preventDefault();

                activeCategory = option.dataset.filter || '';

                categoryOptions.forEach((btn) => {
                    if (btn === option) {
                        btn.classList.add('active');
                    } else {
                        btn.classList.remove('active');
                    }
                });

                if (resultsLabel) {
                    resultsLabel.textContent = option.textContent.trim();
                }

                applyFilters();
            });
        });

        if (searchInput) {
            searchInput.addEventListener('input', () => {
                searchQuery = searchInput.value.toLowerCase();
                applyFilters();
            });
        }

        const searchButton = listingNewsSection.querySelector('.filter-search button');
        if (searchButton) {
            searchButton.addEventListener('click', (event) => {
                event.preventDefault();
                searchQuery = searchInput ? searchInput.value.toLowerCase() : '';
                applyFilters();
            });
        }

        applyFilters();
    });














/*




    // Lenis
    const lenis = new Lenis({ 
      duration: 1.05, 
      smoothWheel: true 
    });

    // Keep ScrollTrigger in sync with Lenis and drive Lenis via GSAP's ticker
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((t) => lenis.raf(t * 1000));
    gsap.ticker.lagSmoothing(0);

  function swipeIn() {
    const panel = document.getElementById('swipe');
    panel.style.zIndex = 9999;
    return gsap.fromTo(panel,
      { y: "100%" },
      {
        y: "0%",
        duration: 0.65,
        ease: "power2.inOut"
      }
    ).then(() => true);
  }

  function swipeOut() {
    const panel = document.getElementById('swipe');
    return gsap.to(panel, {
      y: "-100%",
      duration: 0.65,
      ease: "power2.inOut",
      delay: 0,
      onComplete: () => {
        panel.style.zIndex = -10;
        gsap.set(panel, { y: "100%" });
      }
    }).then(() => true);
  }

  function fadeOut(el) {
    return gsap.to(el, { opacity: 0, duration: 0.25 }).then(() => true);
  }
  function fadeIn(el) {
    return gsap.fromTo(el, { opacity: 0 }, { opacity: 1, duration: 0.35 }).then(() => true);
  }


  // Mega menu visibility toggle
  const initToggleMegaVisibility = () => {
    if (window.__megaVisibilityBound) return;
    window.__megaVisibilityBound = true;
    const getMenu = () => document.querySelector('.mega-menu');
    const getToggleBtn = () => document.querySelector('.hmenu-btn');
    const prepareMenu = () => {
      const menu = getMenu();
      if (!menu || menu.__megaPrepared) return menu;

      const menuItems = menu.querySelectorAll('.main-menu > li');
      menuItems.forEach((item, index) => {
        item.style.setProperty('--mega-item-delay', `${index * 70}ms`);
      });

      const handleTransitionEnd = (event) => {
        if (event.target !== menu || event.propertyName !== 'transform') return;
        if (menu.classList.contains('show')) {
          menu.classList.add('items-visible');
        }
      };

      menu.addEventListener('transitionend', handleTransitionEnd);
      menu.__megaPrepared = true;
      return menu;
    };
    const openMenu = () => {
      const menu = prepareMenu();
      if (!menu) return;
      menu.classList.add('show');
      document.body.classList.add('overflow-hidden');
      document.body.classList.add('mmenu-open');
      const toggleBtn = getToggleBtn();
      if (toggleBtn) toggleBtn.classList.add('is-open');
    };
    const closeMenu = () => {
      setTimeout(() => {          
        const menu = getMenu();
        if (!menu) return;
        menu.classList.remove('items-visible');
        menu.classList.remove('show');
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('mmenu-open');
        const toggleBtn = getToggleBtn();
        if (toggleBtn) toggleBtn.classList.remove('is-open');
      }, 800);
    };

    // Expose for transitions
    window.__closeMegaMenu = closeMenu;

    document.addEventListener('click', (e) => {
      const menu = getMenu();
      if (!menu) return;

      const openBtn  = e.target.closest('.hmenu-btn');
      const closeBtn = e.target.closest('.close-menu');
      const menuLink = e.target.closest('.main-menu li a, .mega-menu a');

      if (openBtn) {
        if (menu.classList.contains('show')) closeMenu(); else openMenu();
        return;
      }
      if (closeBtn || (menu.classList.contains('show') && menuLink)) {
        closeMenu();
      }
    }, { passive: true });
  };

  // SHow hide/header
  const initShowHideHeader = () => {

      var siteHeader = document.querySelector('#masthead');
      var header_progress = 0;
      var header_direction = 1;
      ScrollTrigger.create({
        trigger: "#page",
        start: "top top",
        end: 'bottom bottom',
        onUpdate: function(self) {
          header_progress = self.progress.toFixed(2);
          header_direction = self.direction;

          var newClassName;

          if ( header_progress === '0.00' ) {
            // newClassName = 'siteHeader siteHeader--top';
            siteHeader.classList.add('siteHeader--top');
            siteHeader.classList.remove('siteHeader--notTop');
            siteHeader.classList.remove('siteHeader--bottom');
            siteHeader.classList.remove('siteHeader--unpinned');


          } else if ( header_progress === '1.00' ) {
            // newClassName = 'siteHeader siteHeader--notTop siteHeader--bottom';

            siteHeader.classList.add('siteHeader--notTop');
            siteHeader.classList.add('siteHeader--bottom');
            siteHeader.classList.remove('siteHeader--top');
            siteHeader.classList.remove('siteHeader--unpinned');


          } else {
            // newClassName = 'siteHeader siteHeader--notTop';

            siteHeader.classList.add('siteHeader--notTop');
            siteHeader.classList.remove('siteHeader--top');
            siteHeader.classList.remove('siteHeader--bottom');
            siteHeader.classList.remove('siteHeader--unpinned');

            if ( header_direction === 1 ) {
              // newClassName += ' siteHeader--unpinned';

              siteHeader.classList.add('siteHeader--unpinned');
              siteHeader.classList.remove('siteHeader--top');
              siteHeader.classList.remove('siteHeader--bottom');
              siteHeader.classList.remove('siteHeader--notTop');

            }
          }

          // siteHeader.className = newClassName;
        }
      });

  };

  // Accordion
  const initAccordionDelegation = () => {
    if (window.__accordionBound) return;
    window.__accordionBound = true;

    const updateToggleText = (item, text) => {
      const label = item.querySelector('.more .l_text');
      if (label) label.textContent = text;
    };

    const closeItem = (item) => {
      if (!item || !item.classList.contains('is-open')) return;
      const panel = item.querySelector('.acc-text');
      if (!panel) return;
      try { gsap.killTweensOf(panel); } catch {}

      item.classList.remove('is-open');
      updateToggleText(item, 'Read More');

      const fromH = panel.scrollHeight;
      panel.style.overflow = 'hidden';
      panel.style.height = fromH + 'px';
      gsap.to(panel, {
        height: 0,
        opacity: 0,
        duration: 0.22,
        ease: 'power1.in',
        onComplete: () => {
          panel.classList.add('hidden');
          panel.style.removeProperty('height');
          panel.style.removeProperty('overflow');
          panel.style.removeProperty('opacity');
        }
      });
    };

    const openItem = (item) => {
      if (!item || item.classList.contains('is-open')) return;
      const panel = item.querySelector('.acc-text');
      if (!panel) return;
      try { gsap.killTweensOf(panel); } catch {}

      item.classList.add('is-open');
      updateToggleText(item, 'Read Less');

      panel.classList.remove('hidden');
      panel.style.overflow = 'hidden';
      panel.style.height = 'auto';
      const toH = panel.scrollHeight;
      panel.style.height = '0px';
      gsap.to(panel, {
        height: toH,
        opacity: 1,
        duration: 0.28,
        ease: 'power1.out',
        onComplete: () => {
          panel.style.height = 'auto';
          panel.style.removeProperty('overflow');
          panel.style.removeProperty('opacity');
        }
      });
    };

    document.addEventListener('click', (e) => {
      const header = e.target.closest('.accordion-item .acc-title');
      if (!header) return;
      const item = header.closest('.accordion-item');
      if (!item) return;
      const accordion = item.closest('.accordion');

      if (item.classList.contains('is-open')) {
        closeItem(item);
        return;
      }

      if (accordion) {
        accordion.querySelectorAll('.accordion-item.is-open').forEach((openItem) => {
          if (openItem !== item) closeItem(openItem);
        });
      }

      openItem(item);
    });
  };

  // In-view animations
  const initInViewAnimations = (scope = document) => {

    
    // 1) Straight line grow (scaleX 0 -> 1)
    gsap.utils.toArray(scope.querySelectorAll('.js-line')).forEach((el) => {
      gsap.set(el, { scaleX: 0, transformOrigin: '0% 50%' });
      gsap.to(el, {
        scaleX: 1,
        duration: 2,
        ease: 'power2.out',
        stagger: 0.06,
        scrollTrigger: {
          trigger: el,
          start: 'top 85%',
          toggleActions: 'play none none reverse',
          once: true
        }
      });
    });

    const vlines = gsap.utils.toArray(scope.querySelectorAll('.js-vline'));
    ScrollTrigger.batch(vlines, {
      start: 'top 85%',
      once: true,
      onEnter: (batch) => {
        gsap.set(batch, { scaleY: 0, transformOrigin: '0% 0%' });
        gsap.to(batch, {
          scaleY: 1,
          duration: 2,
          ease: 'power2.out',
          stagger: { each: 0.1, from: 'start' }
        });
      }
    });

    gsap.utils.toArray(scope.querySelectorAll('.js-split-lines')).forEach((el) => {
        const runSplit = () => {
          gsap.set(el, { autoAlpha: 1 });
          const split = new SplitText(el, { type: 'lines' });
          gsap.from(split.lines, {
            yPercent: 100,
            duration: 1,
            ease: 'power2.out',
            stagger: 0.1,
            scrollTrigger: {
              trigger: el,
              start: 'top 85%',
              once: true,
            },
          });
        };

        if (document.fonts?.status === 'loaded') {
          runSplit();
        } else {
          document.fonts.ready.then(runSplit);
        }
    });


    const animationFade = document.querySelectorAll('.js-fade');
    if (animationFade) {
        gsap.set(animationFade, { y: 16, autoAlpha: 0 });
        ScrollTrigger.batch(".js-fade", {
            start: 'top 85%',
            once: true,
            onEnter: elements => {
                gsap.to(elements, {
                    autoAlpha: 1,
                    y: 0,
                    stagger: 0.12
                });
            },
        });
    }

    gsap.utils.toArray(scope.querySelectorAll('.js-video-inview')).forEach((video) => {
      const triggerEl = video.closest('.block-half-textvideo') || video;
      const safePlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      ScrollTrigger.create({
        trigger: triggerEl,
        start: 'top 70%',
        end: 'bottom 30%',
        onEnter: safePlay,
        onEnterBack: safePlay,
        onLeave: () => video.pause(),
        onLeaveBack: () => video.pause(),
      });
    });



    // 4) Image swipe reveal (downwards) with dynamic grid-based stagger
    const getCols = (container) => {
      try {
        const cs = getComputedStyle(container);
        const gtc = cs.gridTemplateColumns;
        if (!gtc || gtc === 'none') return 1;
        const rep = gtc.match(/repeat\(\s*(\d+)/);
        if (rep) {
          const n = parseInt(rep[1], 10);
          if (!Number.isNaN(n) && n > 0) return n;
        }
        const cleaned = gtc.replace(/\(.*?\)/g, '').trim();
        const count = cleaned.split(/\s+/).filter(Boolean).length;
        return Math.max(1, count || 1);
      } catch { return 1; }
    };

    gsap.utils.toArray(scope.querySelectorAll('.js-swipe-img')).forEach((wrap, globalIndex) => {
      const cover = wrap.querySelector('.reveal');
      const media = wrap.querySelector('img, picture, video, .media');
      if (!cover || !media) return;

      const grid = wrap.closest('.grid') || wrap.parentElement;
      const siblings = grid ? Array.from(grid.querySelectorAll('.js-swipe-img')) : [];
      const cols = grid ? getCols(grid) : 1;
      const idx = siblings.length ? siblings.indexOf(wrap) : globalIndex;
      const colIndex = cols > 1 ? (idx % cols) : 0;
      const each = 0.08; // per-column delay
      const d = colIndex * each;

      gsap.set(cover, { yPercent: 0 });
      gsap.set(media, { scale: 1.04 });
      const tl = gsap.timeline({
        scrollTrigger: { 
          trigger: wrap, 
          start: 'top 85%', 
          once: true 
        }
      });
      tl.to(cover, { 
        yPercent: 100, 
        duration: 2, 
        ease: 'power2.out',
        delay: d
      }, 0)
        .to(media, { 
          scale: 1, 
          duration: 0.7, 
          ease: 'power2.out',
          delay: d + 0.05
        }, 0);
    });
  };

  // Back to top
  const initBackTop = () => {
    if (window.__backTopBound) return;
    window.__backTopBound = true;
    // Delegate to handle dynamically replaced DOM with Barba
    document.addEventListener(
      'click',
      (e) => {
        const trigger = e.target.closest('#back-top, .back-to-top');
        if (!trigger) return;
        e.preventDefault();
        if (lenis && typeof lenis.scrollTo === 'function') {
          lenis.scrollTo(0);
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      },
      { passive: false }
    );
  };

    // Animate form LABEL
    function initFormAnimations() {
        function checkInputValue(input) {
            const parentLi = input.closest('.gfield');
            if (input.value) {
                parentLi.classList.add('filled');
            } else {
                parentLi.classList.remove('filled');
            }
        }
    
        const inputs = document.querySelectorAll('.gfield input, .gfield textarea');
    
        inputs.forEach(input => {
            checkInputValue(input);
    
            input.addEventListener('focus', function() {
                const parentLi = input.closest('.gfield');
                parentLi.classList.add('focused');
            });
    
            input.addEventListener('blur', function() {
                const parentLi = input.closest('.gfield');
                parentLi.classList.remove('focused');
                checkInputValue(input);
            });
    
            input.addEventListener('input', function() {
                checkInputValue(input);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        initFormAnimations();
    
        // Create a MutationObserver to watch for changes in the form
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                // Reinitialize form animations on any added nodes
                if (mutation.addedNodes.length) {
                    initFormAnimations();
                }
            });
        });
    
        // Observe the document body or a specific form container
        const formContainer = document.querySelector('body'); // or a specific form container
        if (formContainer) {
            observer.observe(formContainer, { childList: true, subtree: true });
        }
    });



  // (re)initialize per-page JS here
  const boot = (scope = document, incomingBodyClass = document.body.dataset?.bodyClass || document.body.className) => {
    if (incomingBodyClass) {
      document.body.className = incomingBodyClass;
      document.body.dataset.bodyClass = incomingBodyClass;
    }
    // e.g. re-init sliders, lightboxes, ACF maps, etc.
    const header = document.querySelector('#masthead');
    if (header) {
      header.classList.add('siteHeader--top');
      header.classList.remove('siteHeader--notTop', 'siteHeader--bottom', 'siteHeader--unpinned');
    }
    initToggleMegaVisibility();
    initShowHideHeader();
    initAccordionDelegation();
    initInViewAnimations(scope);
    initBackTop();
  };

  const extractBodyClass = (html) => {
    if (!html) return '';
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      return doc.body?.dataset?.bodyClass || doc.body?.className || '';
    } catch {
      return '';
    }
  };

*/
}
